// TODO: (important) Finalize this file and remove eslint-disable after approval has been confirmed. Extract any remaining text from the file and add it to the appropriate i18n file or backend (?).
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';

import {
  ContentHeader,
  RewardMenu,
  APIHandler,
  DataHandler,
  StorageHandler,
} from 'C4';

import { baseAppId, storageKeys } from 'settings';

const trackShare = () => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      APIHandler.trackEvent(
        appId,
        email,
        'collateral',
        'rewards',
        `${window.location.href}/main/rewards`,
        'rewards'
      ).then(() => {});
    });
  });
};

const contentClickHandler = (e) => {
  const targetLink = e.target.closest('link');
  if (!targetLink) return;
  e.preventDefault();

  this.props.history.push(e.target.href);
};

const CurrentContest = ({ contests, showDate = false }) => {
  const contest = contests[0];
  const { title, description } = contest;
  const startDate = new Date(contest.start_date).toDateString();
  const endDate = new Date(contest.end_date).toDateString();

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  return (
    <div
      className="current-contest__container"
      onClick={contentClickHandler}
      role="menuitem"
      tabIndex={0}
      aria-hidden="true"
    >
      <div id="current-contest">
        <h6
          className="current-contest__title"
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <p
          className="current-contest__description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
        {showDate && (
          <p className="current-contest__dates">
            <span className="from">{i18n.translate('general.from')}</span>{' '}
            {startDate}{' '}
            <span className="to">{i18n.translate('general.to')}</span> {endDate}
          </p>
        )}
        <p className="current-contest__terms">
          <a
            href={'https://www.visitlauderdale.com/terms-and-conditions/'}
            className="linkTerms"
            data-fancybox
            data-type="iframe"
          >
            {i18n.translate('rewards.home.contestTerms')}
          </a>

          {/* {mobile && (
              <Link to="/main/rewards/terms?mobile=true" className="linkTerms">
                {i18n.translate("rewards.home.contestTerms")}
              </Link>
            )}
            {!mobile && (
              <Link to="/main/rewards/terms" className="linkTerms">
                {i18n.translate("rewards.home.contestTerms")}
              </Link>
            )} */}
        </p>
      </div>
    </div>
  );
};

/**
 * `RewardsView`
 *
 * @returns {JSX.Element}
 */
const RewardsView = () => {
  const [email, setEmail] = useState('');
  const [contests, setContests] = useState([]);

  const params = new URLSearchParams(window.location.search);
  let mobile = false;
  if (params.get('mobile')) {
    mobile = true;
  }

  // TODO If ?mobile=true is in the URL, load accesstoken and set email based on URL params
  useEffect(() => {
    if (contests.length === 0) {
      StorageHandler.load(storageKeys.lang).then(async (lang) => {
        const result = await APIHandler.getContests(baseAppId, {
          currentDate: new Date().toISOString(),
          marketFilter: [{ id: lang.code.toUpperCase() }],
        });

        if (Array.isArray(result) && result.length > 0) {
          const token = await StorageHandler.load(storageKeys.accessToken);

          const data = await Promise.all(
            result.map(async (contest) => {
              const rewards = await APIHandler.getRewards(
                baseAppId,
                token,
                contest.start_date,
                contest.end_date
              );

              return {
                ...contest,
                entriesCount: Array.isArray(rewards.response)
                  ? rewards.response.length
                  : 0,
              };
            })
          );
          setContests(data);
        }
      });
    }
  }, [contests, setContests]);

  // Track share event
  useEffect(() => {
    trackShare();
  }, []);

  useEffect(() => {
    document.body.classList.remove('no-scroll');
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        setEmail((prev) => (res.email !== prev ? res.email : prev));
      }
    });
    if (mobile) {
      // Save token and email from URL params
      const token = params.get('token');

      // If there is no token in the url, check the validity of the token currently stored.
      if (!token) {
        const expiredStoredToken = StorageHandler.load(storageKeys.accessToken);
        if (!expiredStoredToken) {
          window.location.href = '/main/logout';
        }
        return;
      }

      const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds
      const now = new Date();
      const expires = new Date(now.getTime() + thirtyDaysInMilliseconds);

      const user = {
        email: params.get('email'),
        expires: expires.getTime(),
      };

      StorageHandler.save(storageKeys.user, user);
      StorageHandler.save(storageKeys.accessToken, token);

      setEmail(params.get('email') || '');
    }
  }, [email, setEmail, mobile, params]);

  return (
    <div className="contentContainer rewardsView">
      <RewardMenu />

      <div className="bodyRewards">
        <div className="holder">
          <ContentHeader
            header={i18n.translate('rewards.title')}
            subtitle={i18n.translate('rewards.subheader')}
            line={false}
          />
          <hr />
          {/* <Link to="/main/rewards" className="linkRewards">
            <ContentHeader
              icon={["fas", "trophy"]}
              header={i18n.translate("rewards.home.currentContest")}
              layout="row"
              line={false}
            />
          </Link> */}
          {contests.length > 0 && (
            <React.Fragment>
              <CurrentContest contests={contests} showDate={false} />
              <hr />
            </React.Fragment>
          )}

          {/* <Link to="/main/rewards/achievements" className="linkRewards">
            <ContentHeader
              icon={["fas", "bars"]}
              header={i18n.translate("rewards.home.trainingAchievements")}
              subtitle={i18n.translate("rewards.home.trainingAchievementsText")}
              layout="row"
            />
          </Link>

          <hr /> */}

          {/* <Link to="/main/rewards/dashboard" className="linkRewards">
            <ContentHeader
              icon={["far", "badge"]}
              header={i18n.translate("rewards.home.bookingContests")}
              subtitle={i18n.translate("rewards.home.bookingContestsText")}
              layout="row"
              line={false}
            />
          </Link>

          <hr /> */}

          {/* <Link to="/main/rewards/form" className="linkRewards">
            <ContentHeader
              icon="upload"
              header={i18n.translate("rewards.home.submitBooking")}
              subtitle={i18n.translate("rewards.home.submitBookingText")}
              layout="row"
              line={false}
            />
          </Link>

          <hr /> */}
        </div>
      </div>

      {mobile && (
        <style>
          {
            '\
    .rewardsView { margin-top: 5rem !important; }.contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; } '
          }
          {'.thankYouView__wrapper { margin-top: 5rem !important; }'}
        </style>
      )}
    </div>
  );
};

export default RewardsView;

CurrentContest.propTypes = {
  contests: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      start_date: PropTypes.string.isRequired,
      end_date: PropTypes.string.isRequired,
    })
  ).isRequired,
  showDate: PropTypes.bool,
};

CurrentContest.defaultProps = {
  showDate: false,
};
